<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="icon/image/flash_on_24px">
<path id="icon/image/flash_on_24px_2" d="M7 2V13H10V22L17 10H13L16 2H7Z" fill="#000"/>
</g>
</svg>
